/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 9/3/2022
 */

import WorkflowDocRefItem from "@shared/Workflow/WorkflowDocRefItem";
import {Type, TypeClass} from "@qwoach/class-transformer-wrapper";
import Discriminator from "@/utils/Discriminator";
import {TraumaWorkflowStateItem} from "@shared/Workflow/WorkflowStateItem-imports";
import {WorkflowStateEnum} from "@shared/Workflow/WorkflowStateEnum";
import {ClearanceLevelEnum} from "@shared/Profile/ClearanceLevelEnum.js";
import FilterableItem from "@shared/Filterable/FilterableItem.js";

@TypeClass(Discriminator.create([
	{ value: () => TraumaWorkflowStateItem, name: "TraumaWorkflowStateItem" },
]))
class WorkflowStateItem extends FilterableItem {

	type: string = null
	workflowId: string = null
	workflowStatus: string = WorkflowStateEnum.INITIAL
	journalEntryId: string = null
	clientId: string = null
	clientName: string = null

	@Type(() => WorkflowDocRefItem)
	docRefsArray: WorkflowDocRefItem[] = []
	nextFollowupDate: number = null
	previousFollowupDate: number = null

	clearanceLevel: ClearanceLevelEnum = ClearanceLevelEnum.PHI


	constructor(type: string = null) {
		super();
		this.type = type;
	}

	findDocRefById(documentId){
		console.log("WorkflowStateItem.findDocRefById: documentId = ", documentId, ", this.docRefsArray = ", this.docRefsArray)
		let index = this.docRefsArray.findIndex(item => item.documentId === documentId)
		if(index >= 0){
			return this.docRefsArray[index]
		}
	}
	findDocRefByType(docType){
		let index = this.docRefsArray.findIndex(item => item.documentType === docType)
		if(index >= 0){
			return this.docRefsArray[index]
		}
	}

	syncOverallStatus(){
		return false
	}
}


export default WorkflowStateItem
